import React from "react";
import { FilterButtonMain } from "./styles/DetailsStyles";
import { Button } from "@mui/material";

const CustomerDetailsFilter = ({
  FilterButton = [],
  clickHandler,
  activeBtn,
  width = false,
  setCurrentPage = () => {},
  CurrentPage = 1,
}) => {
  const SetActiveTab = (index) => {
    if (CurrentPage !== 1) {
      setCurrentPage(1);
    }
    clickHandler(index);
  };
  return (
    <FilterButtonMain width={width}>
      {FilterButton &&
        FilterButton.map((value, index) => {
          return (
            <>
              <Button
                key={value}
                className={activeBtn === index ? "active" : ""}
                onClick={() => SetActiveTab(index)}
              >
                {value}
              </Button>
            </>
          );
        })}
    </FilterButtonMain>
  );
};

export default CustomerDetailsFilter;
